import { render, staticRenderFns } from "./FinancialView.vue?vue&type=template&id=d87ff1a8&scoped=true"
import script from "./FinancialView.vue?vue&type=script&lang=js"
export * from "./FinancialView.vue?vue&type=script&lang=js"
import style0 from "./FinancialView.vue?vue&type=style&index=0&id=d87ff1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87ff1a8",
  null
  
)

export default component.exports